import React from 'react';
import useOnlineStatus from '../hooks/useOnlineStatus';
import OfflineFallback from './OfflineFallback';

/**
 * OnlineOnly — Higher-Order Component wrapper.
 *
 * Usage:
 *   <OnlineOnly featureName="Social Feed">
 *     <SocialFeedPage />
 *   </OnlineOnly>
 *
 * When online:  renders children normally.
 * When offline: renders OfflineFallback with a contextual message.
 */
const OnlineOnly = ({ children, featureName = 'This feature' }) => {
  const isOnline = useOnlineStatus();

  if (!isOnline) {
    return <OfflineFallback featureName={featureName} />;
  }

  return <>{children}</>;
};

export default OnlineOnly;
